import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function AddPortfolio() {

  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("url", url);
    formData.append("image", image);

    try {
      const res = await axios.post(
        "https://apnaqwebx-mern.onrender.com/api/portfolio",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("ADDED:", res.data);
      navigate("/admin/portfoliolist");

    } catch (error) {
      console.error("Error:", error);
      alert("Error adding project");
    }

    setLoading(false);
  };

  return (
    <div className="p-6 md:pt-32 pt-44 max-w-2xl mx-auto">

       <div className="flex justify-between items-center mb-6">
                {/* Heading */}
                <h2 className="text-3xl font-bold text-[#895712] text-center ">
                    Add New Portfolio Project
                </h2>

                <Link to="/admin/portfoliolist" ><i className="fa-solid fa-square-caret-left text-3xl text-[#895712]"></i></Link>
            </div>

      <form onSubmit={handleAdd} className="space-y-5" encType="multipart/form-data">

        {/* TITLE */}
        <div>
          <label className="text-gray-700 font-semibold">Project Title</label>
          <input
            type="text"
            className="w-full mt-1 p-3 border rounded-lg focus:border-[#855109]"
            placeholder="Enter project title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        {/* IMAGE */}
        <div>
          <label className="text-gray-700 font-semibold">Project Image</label>
          <input
            type="file"
            accept="image/*"
            className="w-full mt-1 p-3 border rounded-lg"
            onChange={(e) => setImage(e.target.files[0])}
            required
          />
        </div>

        {/* WEBSITE URL */}
        <div>
          <label className="text-gray-700 font-semibold">Website URL</label>
          <input
            type="text"
            className="w-full mt-1 p-3 border rounded-lg focus:border-[#855109]"
            placeholder="Enter website URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
        </div>

        {/* BUTTON */}
        <button
          type="submit"
          className="w-full py-3 bg-[#855109] text-white font-bold rounded-lg hover:bg-[#6e4208] transition disabled:bg-gray-400"
          disabled={loading}
        >
          {loading ? "Adding..." : "Add Project"}
        </button>

      </form>
    </div>
  );
}
